import styled from 'styled-components';

import { SectionSliderContainer as DefaultSectionSliderContainer } from '../../../../components/section-slider-container/section-slider-container';

const darkModeBackgroundColor = '#212a36';
const lightModeBackgroundColor = '#f7f2eb';

type SectionSliderContainerProps = {
  darkMode?: boolean;
};
export const SectionSliderContainer = styled(
  DefaultSectionSliderContainer
)<SectionSliderContainerProps>`
  padding-top: 2.5em;
  padding-bottom: 2.5em;
  background-color: ${({ darkMode }) =>
    darkMode ? darkModeBackgroundColor : lightModeBackgroundColor};
`;
